import React, { useCallback } from 'react';

import type { PromptEditor } from '@atlassian/generative-ai-modal/screens/UserInputCommandPalette';

import type { AdvancedPrompt, EditorPluginAIConfigItem } from '../../../config-items/config-items';
import type { CommandPaletteEvent } from '../../command-palette-state-machine';

interface Props {
	promptEditor: PromptEditor;
	sendToCommandPalette: (event: CommandPaletteEvent) => void;
	advancedPrompt: EditorPluginAIConfigItem['advancedPrompt'];
}

export function usePromptBuilder({ advancedPrompt, sendToCommandPalette, promptEditor }: Props) {
	const handleSubmit = useCallback(
		(prompt: AdvancedPrompt) => {
			sendToCommandPalette({
				type: 'onAdvancedPromptChanged',
				prompt,
			});
		},
		[sendToCommandPalette],
	);

	if (!advancedPrompt) {
		return undefined;
	}

	const PromptBuilder = advancedPrompt.promptBuilder;

	return <PromptBuilder promptEditor={promptEditor} onSubmit={handleSubmit} />;
}
